export default "__VITE_ASSET__d2c83170__"